import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { PortalGlobals } from '../../../../portalglobals'
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'NEJEconfirmation',
    templateUrl: 'confirmation.html'
})
export class NEJEConfirmationComponent implements OnInit, OnDestroy {
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    ErrorMessages: any[]
    baseTitle: string

    constructor(private router: Router, 
        private _enrollementGateway: EnrollmentGateway, 
        public _global: PortalGlobals,
        private titleService: Title) 
    {
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    ngOnInit() {
        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle( this.baseTitle + ' - Saved Enrollment')

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
    }

    enrollNewClient(): void {
        this.enrollment = {} as EnrollmentViewModel
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
    }

    completeEnrollment(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step2'])
    }
}
